import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import {
  hideProngNumber,
  hideBasketStyle,
  showProngPanel,
  hideCathedralShoulders
} from '../../../utils/jewelry-validation'

class ProngPanel extends Component {
  render () {
    const props = this.props
    const getProngStyleOptions = () => {
      const disableProngStyle = props =>
        props.shapes[0] === 'princess' ||
        props.shapes[0] === 'trilliant'

      let options = [
        {value: 'single_rounded', label: 'Single rounded'},
        {value: 'double_rounded', label: 'Double rounded', disabled: disableProngStyle(props)},
        {value: 'single_cat_claw', label: 'Single cat claw', disabled: disableProngStyle(props)},
        {value: 'double_cat_claw', label: 'Double cat claw', disabled: disableProngStyle(props)},
        {value: 'bezel', label: 'Bezel'},
        {value: 'v_bracket', label: 'V-Bracket', disabled: props.shapes[0] !== 'princess' && props.shapes[0] !== 'trilliant'}
      ]

      return options
    }

    const getProngNumberOptions = () => {
      let options = [
        {value: 4, label: '4'},
        {value: 5, label: '5'},
        {value: 6, label: '6'}
      ]

      return options
    }

    const getBasketStyleOptions = () => {
      const disableOption = props =>
        props.prong_number === 5 ||
        props.prong_number === 6 ||
        props.shapes[0] === 'pear' ||
        props.shapes[0] === 'marquise' ||
        props.shapes[0] === 'heart' ||
        props.shapes[0] === 'trilliant'

      let options = [
        {value: 'v_basket', label: 'V-Basket', disabled: disableOption(props)},
        {value: 'double_gallery', label: 'Double Gallery'},
        {value: 'lucida', label: 'Lucida', disabled: disableOption(props)},
        {value: 'custom_style', label: 'Custom Style'}
      ]

      return options
    }

    const getCathedralShouldersOptions = () => {
      const disableNo = props =>
        props.basket_style === 'lucida'

      const disableHalfDiamond = props =>
        !props.diamonds_on_outside_sides_of_shank

      let options = [
        {value: 'no', label: 'No', disabled: disableNo(props)},
        {value: 'yes', label: 'Yes'},
        {value: 'half_diamond', label: 'Yes (Half Diamond)', disabled: disableHalfDiamond(props)}
      ]

      return options
    }
    return (
      <JewelryPanel
        id='prongPanel'
        show={showProngPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          label='Prong Style'
          labelId='prong_style'
          id='prongStyle'
          options={getProngStyleOptions()}
          value={props.prong_style}
          onChange={props.onChangeVal.bind(this, 'prong_style')}
          initVal={null}
        />

        <Spacer xxs hide={hideProngNumber(props)} />

        <SelectItem
          id='prongNumber'
          label='Prong Number'
          labelId='prong_number'
          options={getProngNumberOptions()}
          value={props.prong_number}
          onChange={props.onChangeVal.bind(this, 'prong_number')}
          hide={hideProngNumber(props)}
          initVal={null}
        />

        <Spacer xxs hide={hideBasketStyle(props)} />

        <SelectItem
          id='basketStyle'
          label='Basket Style'
          labelId='basket_style'
          options={getBasketStyleOptions()}
          value={props.basket_style}
          onChange={props.onChangeVal.bind(this, 'basket_style')}
          hide={hideBasketStyle(props)}
          initVal={null}
        />

        <Spacer xxs hide={hideCathedralShoulders(props)} />

        <SelectItem
          id='cathedralShoulders'
          label='Cathedral Shoulders'
          labelId='cathedral_shoulders'
          options={getCathedralShouldersOptions()}
          value={props.cathedral_shoulders}
          onChange={props.onChangeVal.bind(this, 'cathedral_shoulders')}
          hide={hideCathedralShoulders(props)}
          initVal={null}
        />
      </JewelryPanel>
    )
  }
}

export default ProngPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/prong-panel/index.js